// TODO: Fix hover disabled

const buttonDisabledDecorator = (disabled, style, theme, buttonStyle) => {
  if (disabled) {
    switch (buttonStyle) {
      case 'aux':
      case 'secondary':
      case 'tertiary':
        {
          return {
            ...style,
            '&.Mui-disabled': {
              cursor: theme.tokens.ComponentBtnDisabledCursor,
              boxShadow: 'none',
              pointerEvents: 'unset',
              borderColor: buttonStyle === 'aux' ? 'none' : theme.tokens.ComponentBtnDisabledBorder,
              backgroundColor: 'transparent',
              color: theme.tokens.ComponentBtnDisabledColor,
              '&:hover': {
                borderColor: theme.tokens.ComponentBtnDisabledBorder,
                color: theme.tokens.ComponentBtnDisabledColor,
                cursor: theme.tokens.ComponentBtnDisabledCursor
              }
            }
          };
        }
      default:
        {
          return {
            ...style,
            '&.Mui-disabled': {
              cursor: theme.tokens.ComponentBtnDisabledCursor,
              boxShadow: 'none',
              pointerEvents: 'unset',
              backgroundColor: theme.tokens.ComponentBtnDisabledBg,
              borderColor: theme.tokens.ComponentBtnDisabledBorder,
              color: theme.tokens.ComponentBtnDisabledColor,
              '&:hover': {
                backgroundColor: theme.tokens.ComponentBtnDisabledBg,
                borderColor: theme.tokens.ComponentBtnDisabledBorder,
                color: theme.tokens.ComponentBtnDisabledColor,
                cursor: theme.tokens.ComponentBtnDisabledCursor
              }
            }
          };
        }
    }
  } else {
    return style;
  }
};
export default buttonDisabledDecorator;